export default ({ attach, theme, TOOLTIP }) => ({
  MuiTooltip: {
    popper: {
      opacity: 1
    },
    tooltip: {
      fontSize: 13,
      color: theme.palette.primary.main,
      backgroundColor: '#ffffff',
      boxShadow: '0 0 .5rem rgba(0, 0, 0, 0.5);'
    },
    [attach(TOOLTIP.tooltipplacementbottom)]: {
      position: 'relative',
      top: '-.5rem'
    },
    [attach(TOOLTIP.tooltipplacementtop)]: {
      position: 'relative',
      bottom: '-.5rem'
    }
  }
});
